let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dARjk")).then(() => parcelRequire('kk2pa'));